// extracted by mini-css-extract-plugin
export var codeButtonsItem = "code_buttons-module--codeButtonsItem--yXQhC";
export var codeButtonsList = "code_buttons-module--codeButtonsList--BZY++";
export var githubButton = "code_buttons-module--githubButton--A8d6b";